export default {
  booking: require('./booking').default,
  booking_request: require('./booking_request').default,
  booking_details: require('./booking_details').default,
  conversation: require('./conversation').default,
  currency: require('./currency').default,
  landing: require('./landing').default,
  navigation: require('./navigation').default,
  search: require('./search').default,
  contact: require('./contact').default,
  modal: require('./modal').default,
  tour_availability: require('./tour_availability').default,
  integration: require('./integration').default,
  message: require('./message').default,
  pricing: require('./pricing').default,
  viewport: require('./viewport').default,
};
